/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const FlightRight: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.029 11.85c0-.379-.14-.701-.402-.964a1.32 1.32 0 00-.964-.402H15.51l-5.165-8.77h-1.86l2.09 8.77-4.982.023L3.62 8.12h-1.86l1.011 3.73-1.056 3.766h1.834l2.043-2.398 4.959-.023L8.3 22.01h1.848l5.337-8.816h5.18c.378 0 .7-.127.963-.39.266-.266.402-.588.402-.955h-.002z"
      />
    </Icon>
  );
};

export default FlightRight;

FlightRight.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
